import { render, staticRenderFns } from "./ViewTransfer.vue?vue&type=template&id=2dbcd441&"
import script from "./ViewTransfer.vue?vue&type=script&lang=js&"
export * from "./ViewTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports